export default {
  GameCode: "GameCode",
  GameIsStarted: "GameIsStarted",
  GameHostId: "GameHostId",
  GamePlayer: "GamePlayer",
  GamePlayers: "GamePlayers",
  GameRoundState: "GameRoundState",
  GamePlayersNumber: "GamePlayersNumber",
  GameRemainingPlayersNumber: "GameRemainingPlayersNumber",
  GameFascistsIndexes: "GameFascistsIndexes",
  GameHitlerIndex: "GameHitlerIndex",
  GameLiberalRulesApproval: "GameLiberalRulesApproval",
  GameFascistRulesApproval: "GameFascistRulesApproval",
  GameElectionDeclined: "GameElectionDeclined",
  GameDrawRules: "GameDrawRules",
  GameDiscardRules: "GameDiscardRules",
  GameGameRules: "GameGameRules",
  GameIsPresidentIndex: "GameIsPresidentIndex",
  GameIsChancellorIndex: "GameIsChancellorIndex",
  GameWasPresidentIndex: "GameWasPresidentIndex",
  GameWasChancellorIndex: "GameWasChancellorIndex",
  GameModalActive: "GameModalActive",
  GameDashboardRules: "GameDashboardRules",
  GameActiveAbility: "GameActiveAbility",
  GameChosenPlayerIndex: "GameChosenPlayerIndex",
  GameReturnPresidentIndex: "GameReturnPresidentIndex",
  GameRequestRestart: "GameRequestRestart",
  GameVetoState: "GameVetoState",
};
